import React from 'react';
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import searchIcon from "../../assets/images/search-normal.svg"
import LoanDetails from "../../component/LoanDetails/LoanDetails";
import ADDNewLoans from "../LoansAddNew/AddNewLoans";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {LoansService} from "./LoansService";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {preparePositiveNegativeNumberCell} from "../../utils/PrepareTableCellStyle";
import {css} from "@emotion/css";
import calender from "../../assets/images/calender-1.svg";
import {
    DialogSize,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import DefaultDialogPage from "../../component/defaultDialogPage/DefaultDialogPage";
import {convertPersianDateToUniversalDate, convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";

let selectedItemId = -1
const LoinsList = () => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new LoansService(fundID, token, snackbar, loading)


    // Dialog-start
    const [openDialog, setOpenDialog] = useState(false)
    const handleClose = () => {
        selectedItemId = -1
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
        setOpenDialog(false);
    };
    const handleClickOpen = () => {
        setOpenDialog(true);
    };
    // Dialog-end

    const [pageCount, setPageCount] = useState(5);
    const [itemCount, setItemCount] = useState(2);

    const [loanList, setLoanList] = useState([]);
    const [needRefresh, setNeedRefresh] = useState(false);

    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState("national-code");


    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    const [dateFilters, setDateFilters] = useState({});

    function getListDataFromServer(filter = filterText, filterSelect = filterSelectedValue, _dateFilters = dateFilters) {
        loading(setLoadingStateDispatch(true))

        const _filters = prepareFilter(filter, filterSelect)


        service.getLoansList(fundID, page, {
            ..._filters,
            ..._dateFilters
        })
            .then(response => {
                setLoansListData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت لیست انتقادات و پیشنهادات", snackbar, loading)
        })
    }

    function prepareFilter(filter, type) {
        return type === "groupCode" ? {
            "groupCode": filter
        } : type === "national-code" ? {
            "national-code": filter
        } : type === "group-name" ? {
            "group-name": filter
        } : type === "deposit-account-number" ? {
            "deposit-account-number": filter
        } : ""
    }

    function setLoansListData(loansData) {
        setItemCount(loansData.numberOfItems)
        setPageCount(loansData.totalPage)
        setLoanList([])

        loansData.data.map((item, index) => {
            setLoanList((prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 15) + index + 1,
                    item.firstName,
                    item.lastName,
                    item.nationalCode,
                    item.groupName,
                    item.balance,
                    item.amountOfLoan,
                    item.remindAmount,
                    item.numberOfInstallments,
                    item.grantDate,
                    item.createdBy,
                    item.depositAccountNumber,
                )
            ]))
        })
    }

    function prepareGroupsJsonList(id, number, firstName, lastName, nationalCode, groupName, balance,
                                   amountOfLoan, remindAmountOfLoan, numberOfInstallments, paymentMaturity, createdBy, depositAccountNumber) {
        return {
            id: id,
            number: number,
            loinCode: id,
            depositAccountNumber,
            name: `${firstName} ${lastName}`,
            national_code: nationalCode,
            createdBy: createdBy,
            cash_group: groupName,
            remindAmountOfLoan: remindAmountOfLoan ? convertCurrencyFormat(remindAmountOfLoan) : "0",
            cache: <span className={css`direction: ltr;`}>{preparePositiveNegativeNumberCell(balance)}</span>,
            loinAmount: convertCurrencyFormat(amountOfLoan),
            loinInstallments: convertCurrencyFormat(numberOfInstallments),
            date: moment(paymentMaturity, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'),
        }
    }


    const showLoanContent = (rowId) => {
        selectedItemId = rowId
        setOpenDialog(true);
    }

    const [openDialogAddNewLoan, setOpenDialogAddNewLoan] = useState(false)
    const handleClickOpenAddNewLoan = () => {
        setOpenDialogAddNewLoan(true);
    };
    const handleCloseAddNewLoan = () => {
        selectedItemId = -1
        if (needRefresh) {
            setNeedRefresh(false)
        }
        getListDataFromServer()
        setOpenDialogAddNewLoan(false);
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])

    const [filterDialogOpenState, setFilterDialogOpenState] = useState(false);


    function handleClickOpenDateDialog() {
        setFilterDialogOpenState(true)
    }

    function handleCloseDateDialog() {
        setFilterDialogOpenState(false)
    }

    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");

    function handleDoFilter() {
        setDateFilters(null)
        let _filters = {}

        if (filterStartDate.length === 10) {
            _filters = {
                startDate: convertPersianDateToUniversalDate(filterStartDate)
            }
        }

        if (filterEndDate.length === 10) {
            _filters = {
                ..._filters,
                endDate: convertPersianDateToUniversalDate(filterEndDate)
            }
        }

        if (_filters && (_filters.startDate || _filters.endDate))
            setDateFilters(_filters)

        getListDataFromServer(
            filterText,
            filterSelectedValue,
            _filters
        )

        handleCloseDateDialog()
    }

    return (
        <>

            <DefaultDialogPage
                open={filterDialogOpenState}
                onClose={handleCloseDateDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"فیلتر ها"}
            >
                <RaikoGridOneColumn
                    className={css`padding: 0 1rem .5rem 1rem;`}>

                    <TextField
                        value={convertToBirthDate(filterStartDate)}
                        onChange={e => {
                            setFilterStartDate(convertToBirthDate(e.target.value))
                        }}
                        className="w-100 h-100"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <img src={searchIcon} alt=""/>
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined" label="تاریخ شروع"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <TextField
                        value={convertToBirthDate(filterEndDate)}
                        onChange={e => {
                            setFilterEndDate(convertToBirthDate(e.target.value))
                        }}
                        className="w-100 h-100"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <img src={searchIcon} alt=""/>
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined" label="تاریخ پایان"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <div
                        className={css`
                          display: flex;
                          gap: .5rem;
                          justify-content: end;`}
                    >

                        <Button className="btn-secondary"
                                style={{marginRight: "8px"}}
                                onClick={_ => {
                                    setFilterStartDate("")
                                    setFilterEndDate("")
                                    handleDoFilter()
                                }}>
                            پاک کردن
                        </Button>

                        <RaikoButtonPrimary
                            label={"اعمال فیلتر"}
                            onClick={handleDoFilter}
                        />
                    </div>

                </RaikoGridOneColumn>
            </DefaultDialogPage>

            {
                <LoanDetails
                    openDialog={openDialog}
                    handleClose={handleClose}
                    handleClickOpen={handleClickOpen}
                    selectedLoanId={selectedItemId}
                    needRefresh={setNeedRefresh}
                />
            }
            {
                <ADDNewLoans
                    openDialog={openDialogAddNewLoan}
                    handleClose={handleCloseAddNewLoan}
                    handleClickOpen={handleClickOpenAddNewLoan}
                    needRefresh={setNeedRefresh}
                />
            }

            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'start'}}>
                        <Typography variant={"h5"}>
                            وام ها
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + ` وام ثبت شده ` +
                                    `${(
                                        dateFilters && dateFilters.startDate && dateFilters.startDate.length === 10) ||
                                    (dateFilters && dateFilters.endDate && dateFilters.endDate.length === 10) ? `
                                     - فیلتر ها : ${dateFilters && dateFilters.startDate && dateFilters.startDate.length === 10 ?
                                            `تاریخ شروع: ${convertUniversalDateToPersianDate(dateFilters.startDate)}` : ""} -
                                             ${dateFilters && dateFilters.endDate && dateFilters.endDate.length === 10 ?
                                            `تاریخ پایان: ${convertUniversalDateToPersianDate(dateFilters.endDate)}` : ""}` :
                                        ""}`}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={() => {
                            setOpenDialogAddNewLoan(true)
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن وام جدید
                    </Button>
                </Box>
                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '0 0 1.2rem 0',
                         justifyContent: 'start',
                         alignContent: 'start',
                         alignItems: 'start'
                     }}>
                    <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid sm={12} md={8} lg={4} xl={4} className="d-flex flex-row flex-nowrap alignItemsCenter">
                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select label="جستجو بر اساس"
                                    value={filterSelectedValue}
                                    onChange={e => {
                                        setFilterSelectedValue(e.target.value)
                                        getListDataFromServer(filterText, e.target.value)
                                    }}>
                                <option value={"national-code"}>کد ملی</option>
                                <option value={"group-name"}>نام گروه</option>
                                <option value={"groupCode"}>کد گروه</option>
                                <option value={"deposit-account-number"}>شماره حساب</option>
                            </Select>
                        </FormControl>
                        <button className="btn-date"
                                onClick={handleClickOpenDateDialog}>
                            <img src={calender} style={{height: "56px"}} alt=""/>
                        </button>
                    </Grid>

                </Box>


                <CustomTable
                    header={columns}
                    data={loanList}
                    rowClicked={showLoanContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default LoinsList;

const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'loinCode',
        label: 'شناسه وام',
        align: 'right',
    },
    {
        id: 'depositAccountNumber',
        label: 'حساب',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'national_code',
        label: 'کد ملی',
        align: 'right',
    },

    {
        id: 'createdBy',
        label: 'سازنده',
        align: 'right',
    },
    {
        id: 'cash_group',
        label: 'گروه',
        align: 'right',
    },
    {
        id: 'cache',
        label: 'موجودی حساب (ریال)',
        align: 'right',
    },
    {
        id: 'loinAmount',
        label: 'مبلغ وام (ریال)',
        align: 'right',
    },
    {
        id: 'remindAmountOfLoan',
        label: 'باقی مانده وام (ریال)',
        align: 'right',
    },
    {
        id: 'loinInstallments',
        label: 'تعداد اقساط',
        align: 'right',
    },
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right',
    },
];